export default "__VITE_ASSET__CHLj5HF9__"